module.exports = __webpack_public_path__ + "img/what-ary-you-waiting.9ea3a37.webp";